import mirrorCreator from 'mirror-creator';
export { default as ActionTypes } from './actionTypes';

export const AlertMessageTypes = mirrorCreator([
  'danger',
  'success',
  'warning'
]);

export const DROPDOWN_SEARCH_MINIMUM = 7;
